<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12)
      n-data-table-card-result.mt-3(
        :headers='headers'
        :items='items'
        :meta='meta' 
        @nextpage='nextpage'
      ) 
        template(#item.rightActionEffectToCard='{item}')
          | {{ item.date | dateFormat}}
    loading-status(:had-data='hadData')

</template>

<script> 
import { st as apiSt } from '@/apis'

export default { 
  data: () => ({ 
    hadData : false,
    items : [],
    meta : {}, 
    page : 1, 
    headers:[   
      { text: 'table.date', value: 'rightActionEffectToCard'},
      { text: 'table.game-not-over', value: 'game_not_over' },
      { text: 'table.game-over', value: 'game_over' },
      { text: 'table.total-game', value: 'total_game' }, 
    ]
  }), 
  async created () {
    await this.load()
  }, 
  methods: {
    async load (params = {}) {
      params.page = this.page
      this.hadData = false 
      const [err,data,,meta ] = await apiSt.getSummary(params)
      this.hadData = true 
      
      if(err){
        this.$alert('',err,'warning')
        return 
      }

      this.items = data
      this.meta = meta 
    },
    nextpage (value) {
        this.page = value
        this.load ()
    }
  }
};
</script> 